import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import TextEditor from "../../../Components/RichTextEditor/TextEditor";
import { BASE_URL } from "../../../Config";
import { Typography } from "antd";

const SHATKARMAS_OPTIONS = [
  { label: "Neti", value: "neti" },
  { label: "Dhauti", value: "dhauti" },
  { label: "Kapalbhati", value: "Kapalbhati" },
  { label: "Others", value: "others" },
];

const WARMUP_OPTIONS = [
  { label: "Warmup", value: "Warmup" },
  { label: "Others", value: "others" },
];

const EditAllPages = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [content, setContent] = useState("");
  const [page, setPage] = useState("");
  const [yogaType, setYogaType] = useState("");
  const [warmupType, setWarmupType] = useState("");
  const [shatkarmasType, setShatkarmasType] = useState("");
  const [loading, setLoading] = useState(true);
  const [categoryContent, setCategoryContent] = useState("");
  const [alphabetContent, setAlphabetContent] = useState("");

  const fetchPage = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/allpages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data.data;

      setContent(data.content);
      setPage(data.page);
      setYogaType(data.yogaType || "");
      setWarmupType(data.warmupType || "");
      setShatkarmasType(data.shatkarmasType || "");
      setCategoryContent(data.categoryContent || "");
      setAlphabetContent(data.alphabetContent || "");

      setLoading(false);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPage();
  }, []);

  const handleUpdate = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const body = {
        page,

        ...(page !== "alternate-asanas" &&
          page !== "do-or-donts" &&
          page !== "how-to-make-variation" &&
          page !== "time" && {
            yogaType,
          }),

        ...(page !== "dictionary" && { content }),

        // ✅ dictionary fields
        ...(page === "dictionary" && {
          categoryContent,
          alphabetContent,
        }),

        ...(page === "warmup" && { warmupType }),
        ...(page === "shatkarmas" && { shatkarmasType }),
      };

      await axios.put(`${BASE_URL}/allpages/${id}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      navigate("/view-allpages");
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Edit Page</h2>

      {/* PAGE DROPDOWN */}
      <div style={{ marginBottom: 20 }}>
        <label>
          <b>Select Page</b>
        </label>
        <select
          value={page}
          onChange={(e) => setPage(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            marginTop: 8,
          }}
        >
          <option value="yoga">Yoga</option>
          <option value="breathe-technique">Breathe Technique</option>
          <option value="warmup">Warmup</option>
          <option value="alternate-asanas">Alternate Asanas</option>
          <option value="do-or-donts">Do or Don’ts</option>
          <option value="how-to-make-variation">How to Make Variation</option>
          <option value="mudra">Mudra</option>
          <option value="tool">Tool</option>
          <option value="time">Time</option>
          <option value="meditations">Meditations</option>
          <option value="shatkarmas">Shatkarmas</option>
          <option value="dictionary">Dictionary</option>
        </select>
      </div>

      {/* YOGA TYPE (Common) */}
      {(page === "yoga" ||
        page === "warmup" ||
        page === "shatkarmas" ||
        page === "meditations" ||
        page === "breathe-technique" ||
        page === "mudra" ||
        page === "dictionary" ||
        page === "tool") && (
        <div style={{ marginBottom: 20 }}>
          <label>
            <b>Yoga Name</b>
          </label>
          <input
            value={yogaType}
            onChange={(e) => setYogaType(e.target.value)}
            placeholder="Enter yoga name…"
            style={{
              width: "100%",
              padding: 10,
              marginTop: 8,
              borderRadius: 6,
              border: "1px solid #ccc",
            }}
          />
        </div>
      )}

      {page === "warmup" && (
        <div style={{ marginBottom: 20 }}>
          <label>
            <b>Warmup Type</b>
          </label>
          <select
            value={warmupType}
            onChange={(e) => setWarmupType(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              marginTop: 8,
            }}
          >
            {WARMUP_OPTIONS.map((opt) => (
              <option value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      )}

      {page === "shatkarmas" && (
        <div style={{ marginBottom: 20 }}>
          <label>
            <b>Shatkarmas Type</b>
          </label>
          <select
            value={shatkarmasType}
            onChange={(e) => setShatkarmasType(e.target.value)}
            style={{
              width: "100%",
              padding: 10,
              marginTop: 8,
            }}
          >
            {SHATKARMAS_OPTIONS.map((opt) => (
              <option value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      )}

      {page === "dictionary" ? (
        <>
          <Typography.Title level={4} style={{ marginTop: 20 }}>
            Dictionary – Category
          </Typography.Title>

          <TextEditor
            initialData={categoryContent}
            onChange={setCategoryContent}
            uploadUrl={`${BASE_URL}/upload`}
          />

          <Typography.Title level={4} style={{ marginTop: 20 }}>
            Dictionary – Alphabet
          </Typography.Title>

          <TextEditor
            initialData={alphabetContent}
            onChange={setAlphabetContent}
            uploadUrl={`${BASE_URL}/upload`}
          />
        </>
      ) : (
        <TextEditor
          initialData={content}
          onChange={setContent}
          uploadUrl={`${BASE_URL}/upload`}
        />
      )}

      <button
        onClick={handleUpdate}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          background: "#1677ff",
          color: "#fff",
          borderRadius: 6,
        }}
      >
        Update
      </button>
    </div>
  );
};

export default EditAllPages;
